import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Timestamp } from '@dixa/lib-shared-habla';
import { SearchResult } from '../../../../result/searchResult';
/**
 * Represents a component that is used to render a single search result in the
 * notes tab
 */
export const NoteResult = ({ hit, className, onRowClick, }) => {
    var _a, _b;
    return (_jsx(SearchResult, { className: className, content: {
            title: (_b = (_a = hit.author) === null || _a === void 0 ? void 0 : _a.display_name) !== null && _b !== void 0 ? _b : '',
            message: (_jsxs("span", Object.assign({ className: "search-result-timestamp" }, { children: ['Created ', _jsx(Timestamp, { relative: true, time: hit.created_at })] }))),
            avatar: _jsx(Avatar, { user: hit.author }),
        }, onClick: () => onRowClick === null || onRowClick === void 0 ? void 0 : onRowClick(hit) }));
};
